// Import the singleton Supabase client
import { supabase } from './supabaseClient'

// Re-export the singleton client for convenience
export { supabase }

// Database schema helpers
export const TABLES = {
  SESSIONS: 'SessionSchedule',
  USERS: 'users',
  INSTRUCTOR_SIGNUPS: 'instructor_signups',
  POINTS: 'user_points'
}

// Real-time subscriptions
export const subscribeToSessions = (callback) => {
  return supabase
    .channel('sessions')
    .on('postgres_changes', 
      { event: '*', schema: 'public', table: TABLES.SESSIONS }, 
      callback
    )
    .subscribe()
}

export const subscribeToSignups = (callback) => {
  return supabase
    .channel('signups')
    .on('postgres_changes', 
      { event: '*', schema: 'public', table: TABLES.INSTRUCTOR_SIGNUPS }, 
      callback
    )
    .subscribe()
}
